export const selectLanguage = (state: any) => state.language;
